
























































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Utilities as utils } from "@/shared/utilities";
import { Locales } from "@/i18n/locales";
@Component
export default class HeaderInfoComponent extends Vue {
  @Prop() appInfo: any;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  formatDateTime(val) {
    return utils.formatDate(val);
  }
}
